import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Display all Office List
export const getOfficeList = createAsyncThunk('data/getOfficeList',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/office/getOffice?page=${data.page}&limit=${data.limit}&search=${data.search}&Role=${data.role}`);
      return res.data
  }
)

//Create Office Details
export const createOfficeDetails = createAsyncThunk('data/createOffice',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/office/createOffice', data);
      return res.data
  }
)

//Update Office Details
export const updateOfficeDetails = createAsyncThunk('data/updateOffice',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/office/updateOffice', data);
      return res.data
  }
)

//Delete Office Details
export const deleteOfficeDetails = createAsyncThunk('data/deleteOfficeDetails',
  async(data)=>{
    const res = await axiosInstance.delete(`/api/v1/office/deleteOffice/${data.Id}?type=${data.type}`);
      return res.data
    }
)